<template>
  <span class="status-badge" :class="`status-badge--${tone}`">{{ label }}</span>
</template>

<script>
import { statusMeta } from '../../utils/formatters';

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      default: 'created',
    },
    customLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    meta() {
      return statusMeta(this.status);
    },
    tone() {
      return this.meta.tone;
    },
    label() {
      return this.customLabel || this.meta.label;
    },
  },
};
</script>

<style scoped src="./StatusBadge.css"></style>
